import { Scroll } from 'components/scroll'

export class HideHeader {
    constructor() {
        this.class = 'scrolled'
        this.bannerClass = 'has-banners'
        this.element = document.querySelector('.navbar')
        if(this.element) {
            this.elementHeight = this.element.clientHeight
            this.stuck = false
            this.stickPoint = this.getDistance();
        }

        this.init()
    }

    init() {

        var scrollFn = this.debounce(function() {
            if(window.pageYOffset >= 200 ){
                if(!document.body.classList.contains(this.class)) {
                    document.body.classList.add(this.class)
                    new Scroll(270, 200, 'easeOutQuad')
                }
            }else {
                if(document.body.classList.contains(this.class)) {
                    document.body.scrollTop = document.documentElement.scrollTop = 0
                    document.body.classList.remove(this.class)
                }
            }
        }, 80).bind(this);

        if(document.body.classList.contains(this.bannerClass))
            window.addEventListener('scroll', scrollFn);
            
    }

    getDistance() {
        return this.element.offsetTop;
    }

    debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/hideHeader.js